/**
 * @generated SignedSource<<eedecf1d1a44384df61803c6e8242791>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type videoGenerationModelsQuery$variables = Record<PropertyKey, never>;
export type videoGenerationModelsQuery$data = {
  readonly videoGenerationModels: ReadonlyArray<{
    readonly allowedAspectRatios: ReadonlyArray<string>;
    readonly allowedDurations: ReadonlyArray<number>;
    readonly allowedResolutions: ReadonlyArray<string>;
    readonly isDefault: boolean;
    readonly maxPromptLength: number;
    readonly model: string;
    readonly supportsGenerateAudio: boolean;
  }>;
};
export type videoGenerationModelsQuery = {
  response: videoGenerationModelsQuery$data;
  variables: videoGenerationModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "VideoGenerationModelInfo",
    "kind": "LinkedField",
    "name": "videoGenerationModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPromptLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedDurations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedResolutions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedAspectRatios",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supportsGenerateAudio",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "videoGenerationModelsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "videoGenerationModelsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "c84b40d83c0c02d52ebaea5816faf0ab",
    "id": null,
    "metadata": {},
    "name": "videoGenerationModelsQuery",
    "operationKind": "query",
    "text": "query videoGenerationModelsQuery {\n  videoGenerationModels {\n    model\n    maxPromptLength\n    allowedDurations\n    allowedResolutions\n    allowedAspectRatios\n    supportsGenerateAudio\n    isDefault\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f1004521f565830cdc0d2191c2fc712";

export default node;
